import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import DataEntry from './views/DataEntry/DataEntry';
import AppProvider from './AppProvider';

import './App.scss';
import Payment from './views/payment/Payment';
import GenericError from './components/errorComponents/GenericError';
import RetryError from './components/errorComponents/RetryError';
import ServiceError from './components/errorComponents/ServiceError';
import RejectError from './components/errorComponents/RejectError';
import PaymentError from './components/errorComponents/paymentError';
import PaymentErrorGeneric from './components/errorComponents/paymentErrorGeneric';
import Successful from './views/Successful/Successful';

export const PAGE_SUCCESS = "/success/:operationId"
export const PAGE_PAYMENT = "/payment/:operationId"
export const PAGE_SUMMARY = "/summary"

// process.env.PUBLIC_URL = '/leonardo'

const App = () => {

    return (
        <Router id="LayoutMain_container" basename={process.env.PUBLIC_URL}>
            <AppProvider>
                <Routes>
                    <Route path="/" element={<DataEntry />} />
                    <Route exact path={PAGE_SUCCESS} element={<Successful />} />
                    <Route exact path={PAGE_PAYMENT} element={<Payment />} />

                    
                    {/* <Route path="/error" element={<GenericError />} /> */}
                    <Route path="/error2" element={<RetryError />} />
                    <Route path="/error3" element={<ServiceError />} />
                    <Route path="/reject-error" element={<RejectError />} />
                    <Route path="/error5" element={<PaymentErrorGeneric />} />
                    <Route path="/error" element={<PaymentError />} />

                    <Route path='*' element={<DataEntry />} />
                </Routes>
            </AppProvider>
        </Router>
    );
}

export default App;